<template>
  <div class="ancho-total">
    <!--
    <button
      class="btn btn-primary ancho-total mt-2 text-white"
      :disabled="
        checked === false ||
          tipoCDP == 0 ||
          (tipoCDP == 2 && (ruc.length != 11 || razsoc == '' || facdir == ''))
      "
      data-toggle="modal"
      data-target="#myModalPagoLinkInComponent"
    >
      Pagar con Pago Link(Niubiz)
    </button>
    -->
    <div
      class="modal fade"
      id="myModalPagoLinkInComponent"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalPagoLinkInComponent"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-body">
            <template v-if="currentPagoLinkStep == 1">
              <h4><strong>Pagar con pago link (NIUBIZ)</strong></h4>
              <br />
              <h2>
                <span style="color: blue;"
                  ><strong>{{ totalValue | currency }}</strong></span
                >
              </h2>
              <br />
              <p>
                Utiliza "Pago Link" para realizar tu pago de
                {{ totalValue | currency }} con el siguiente enlace:
              </p>
              <br />
              <p>
                <a
                  :href="
                    isProdEnviorment
                      ? configData.ecommerceProps.paymentMethods.niubizPagoLink.cdnProd
                      : configData.ecommerceProps.paymentMethods.niubizPagoLink.cdnTest
                  "
                  target="_blank"
                  >{{
                    isProdEnviorment
                      ? configData.ecommerceProps.paymentMethods.niubizPagoLink.cdnProd
                      : configData.ecommerceProps.paymentMethods.niubizPagoLink.cdnTest
                  }} </a
                ><button
                  class="btn-sm btn-secondary"
                  type="button"
                  v-clipboard:copy="
                    isProdEnviorment
                      ? configData.ecommerceProps.paymentMethods.niubizPagoLink.cdnProd
                      : configData.ecommerceProps.paymentMethods.niubizPagoLink.cdnTest
                  "
                >
                  <i class="fa fa-copy"></i><small> Copiar</small>
                </button>
              </p>
              <br />
              <button class="btn btn-primary" @click="currentPagoLinkStep = 2">
                Siguiente
              </button>
            </template>

            <template v-if="currentPagoLinkStep == 2">
              <h4><strong>¿Ya realizaste el pago?</strong></h4>
              <br />
              <div class="modal-footer">
                <button
                  class="btn btn-primary"
                  @click="currentPagoLinkStep = 3"
                  data-dismiss="modal"
                >
                  Si, continuar
                </button>
                <button class="btn btn-primary" @click="currentPagoLinkStep = 1">
                  Cancelar Operaciones
                </button>
              </div>
            </template>
            <template v-if="currentPagoLinkStep == 3">
              <h4>
                <strong>{{ loggedUserData.name_client }}</strong
                >, elige como deseas confirmar tu pago:
              </h4>
              <br />
              <input type="radio" id="uno" value="Uno" v-model="picked" />
              <label for="uno">Código de autorización:</label>
              <br />
              <template v-if="picked == 'Uno'">
                <p>Envía el código de autorización proporcionado por pagolink</p>
                <br />
                <form>
                  <div class="form-group">
                    <input
                      class="form-control"
                      v-model="operation_number"
                      type="text"
                      placeholder="Código de operación"
                      required
                    />
                  </div>

                  <div class="form-group">
                    <input
                      class="form-control"
                      id="voucherFile"
                      type="file"
                      placeholder="Adjuntar voucher"
                      required
                      @change="uploadingFileConfirmation = true"
                      accept="application/pdf, image/png, .jpeg, .jpg, .JEPG"
                    />
                    <small style="color:grey;"
                      ><i>"Solo se aceptan comprobantes en formato .jpg y .pdf"</i></small
                    >
                  </div>
                </form>
              </template>

              <br />
              <input type="radio" id="Dos" value="Dos" v-model="picked" />
              <label for="Dos">Enviar constancia por correo electrónico</label>
              <br />

              <template v-if="picked == 'Dos'">
                <p>Envía la constancia de tu pago a:</p>
                <p>
                  <strong>info.peru@armasperu.com </strong>
                  <button
                    class="btn-sm btn-secondary"
                    type="button"
                    v-clipboard:copy="'Info.peru@iff.com'"
                  >
                    <i class="fa fa-copy"></i><small> Copiar</small>
                  </button>
                </p>
              </template>

              <br />
              <div class="modal-footer">
                <div class="row">
                  <div class="col-sm-12">
                    <template v-if="picked == ''">
                      <button class="btn btn-primary btn-ancho-total" disabled data-dismiss="modal">
                        Confirmar
                      </button>
                    </template>
                    <template v-else-if="picked == 'Uno'">
                      <button
                        class="btn btn-primary btn-ancho-total"
                        :disabled="
                          operation_number == '' || !uploadingFileConfirmation ? true : false
                        "
                        @click="pagoLinktoFinalStep()"
                        data-dismiss="modal"
                      >
                        Confirmar
                      </button>
                    </template>
                    <template v-else>
                      <button
                        class="btn btn-primary btn-ancho-total"
                        @click="pagoLinktoFinalStep()"
                        data-dismiss="modal"
                      >
                        Confirmar
                      </button>
                    </template>
                  </div>
                  <div class="col-sm-12">
                    <br />
                  </div>
                  <div class="col-sm-12">
                    <button
                      class="btn btn-primary btn-ancho-total"
                      @click="currentPagoLinkStep = 1"
                      data-dismiss="modal"
                    >
                      Cancelar Operaciones
                    </button>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toastr from 'toastr';
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import { config_settings } from '@/config.js';
import { UNAUTHORIZED, BAD_GATEWAY } from '@/types/httpd.constants';
import { postCdpPagoLink } from '@/service/process.service';
import { generateChargueData, generateNewAccountForErpRequest } from '@/helpers/cart.helpers';
import {
  generateRefreshTokenBodyRequest,
  getAccessToken,
  deleteCartItems,
} from '@/helpers/localStorage.helpers';

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

export default {
  name: 'NiubizPagoLinkPaymentButton',
  props: [
    'configData',
    'checked',
    'tipoCDP',
    'ruc',
    'razsoc',
    'facdir',
    'loggedUserData',
    'totalValue',
    'cartProducts',
  ],
  data() {
    return {
      id_delivery: localStorage.getItem('id_delivery'),
      day_delivery: localStorage.getItem('day_delivery'),
      ruc_agency: localStorage.getItem('ruc_agency'),
      dir_agency: localStorage.getItem('dir_agency'),
      address_details: JSON.parse(localStorage.getItem('address_details')),
      transport_address_details: JSON.parse(localStorage.getItem('transport_address_details')),
      isProdEnviorment: config_settings.PROD_ENV,
      products_data: [],
      currentPagoLinkStep: 1,
      operation_number: '',
      uploadingFileConfirmation: false,
      picked: '',
      mail_confirm: false,
    };
  },
  methods: {
    pagoLinktoFinalStep() {
      this.currentPagoLinkStep = 1;
      if (this.loggedUserData) {
        if (
          this.loggedUserData.dni_client === '' ||
          this.loggedUserData.phone_client == null ||
          this.loggedUserData.id_district.id_district == 0 ||
          this.loggedUserData.address_client === ''
        ) {
          this.$parent.setErrorMessage(
            'Debe ingresar sus datos completos para poder realizar una compra. Actualize todos sus datos <a href="/perfil">aquí</a> e inténtelo nuevamente.',
          );
        } else {
          this.pagoLinkProcess();
        }
      } else {
        toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
          iconClass: 'customer-danger',
        });
        this.$parent.setErrorMessage('Debe iniciar sesión antes de continuar');
        this.$router.push({ path: '../../inicio/' });
      }
    },

    pagoLinkProcess() {
      this.$parent.setLoadingValue(true);
      this.cartProducts.forEach((product, index) => {
        this.products_data[index] = {
          code_product: product.code_product,
          quantity: product.qty,
          cod_sub_product: product.subproduct.id_lote,
        };
      });
      if (this.picked == 'Uno') {
        this.mail_confirm = true;
      } else if (this.picked == 'Dos') {
        this.mail_confirm = false;
      }
      /*
      const newAccountForErpRequest = generateNewAccountForErpRequest(
        this.tipoCDP,
        this.loggedUserData,
        this.ruc,
        this.razsoc,
        this.address_details,
      );
      this.$parent.createAccountForErp(newAccountForErpRequest);
      */
      const chargueData = generateChargueData(
        this.products_data,
        this.tipoCDP,
        this.ruc,
        this.razsoc,
        this.facdir,
        this.mail_confirm,
        this.operation_number,
        this.id_delivery,
        this.address_details,
        this.day_delivery,
        this.ruc_agency,
        this.dir_agency,
        this.origin_bank,
        this.destiny_bank,
      );
      var formData = new FormData();
      if (this.mail_confirm) {
        formData.append('file', document.getElementById('voucherFile').files[0]);
      } else {
        formData.append('file', new File([''], 'filename'));
      }
      formData.append(
        'chargeData',
        new Blob([JSON.stringify(chargueData)], { type: 'application/json' }),
      );
      postCdpPagoLink(getAccessToken(), formData)
        .then((response) => {
          this.$parent.setLoadingValue(false);
          this.$parent.removeAllProductCart();
          this.$parent.setSucessMessage(
            'Su compra fue efectuada correctamente, se le enviarán los detalles y el cargo a su correo electrónico. Tambien puede revisar el detalle de sus compras y pedidos ',
          );
          this.uploadingFileConfirmation = false;
        })
        .catch((error) => {
          this.$parent.setLoadingValue(false);
          this.uploadingFileConfirmation = false;
          if (error.response.status === UNAUTHORIZED) {
            this.$parent
              .refreshToken()
              .then((_) => {
                this.pagoLinkProcess();
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.$parent.setErrorMessage('Debe iniciar sesión antes de continuar');
                this.$router.push({ path: '../../login/' });
              });
          } else if (error.response.status === BAD_GATEWAY) {
            this.$parent.removeAllProductCart();
            this.$parent.setSucessMessage(
              'Su compra fue efectuada correctamente, sin embargo, es posible que haya existido un error al enviarle los detalles de la transacción al correo electrónico. Puede revisar el detalle de sus compras y pedidos ',
            );
          } else {
            this.$parent.setErrorMessage(
              'Estimado cliente le informamos que no contamos con stock del producto solicitado, es posible que recientemente se haya agotado.',
            );
          }
        });
    },
  },
};
</script>
